import React from 'react';
import {View} from 'MWC';
import abankLogoWhite from '../img/new/abank-logo-white.svg';
import abankLogoBlack from '../img/new/abank-logo-black.svg';
import {ReactSVG} from 'react-svg';
import {canUseDOM} from '../../../helpers/canUseDOM';
import PropTypes from 'prop-types';

class LogoLink extends View {
    constructor(props) {
        super(props);
    }

    static contextTypes = {
        theme: PropTypes.string
    };

    render() {
        const {homeUrl, navigate, className, additionalClickHandler} = this.props;

        return (
            <a
                href={homeUrl}
                onClick={e => {
                    navigate(homeUrl, e);
                    if (additionalClickHandler) {
                        additionalClickHandler();
                    }
                }}
                className={className}
            >
                <ReactSVG src={this.context.theme === 'dark' ? abankLogoWhite : abankLogoBlack} />
            </a>
        );
    }
}

export default LogoLink;
